import { useTranslation } from 'react-i18next'
import { SetupWizardStep, SetupWizardStepComponent } from 'app/menu/components/TopBarV1/setupWizard/SetupWizardStep'
import ReceiptIcon from '@mui/icons-material/Receipt'
import N from 'utils/navigation'

export const InvoiceNumbersVehiclePurchaseCTA: SetupWizardStepComponent = props => {
  const { t } = useTranslation()

  return (
    <SetupWizardStep
      {...props}
      step={{
        icon: <ReceiptIcon />,
        content: t('SetupWizard.InvoiceNumbersSummary_VehiclePurchase'),
        buttonText: t('SetupWizard.InvoiceNumberSequence_VehiclePurchaseCTA'),
        actionOnClick: () => {
          N.push('/settings/invoice-sequences/new/vehicle_purchase')
        }
      }}
    />
  )
}
